import { marked } from 'marked';

// Eagerly load every guide markdown file as a raw string at build time.
// (Vite 4 glob syntax: { as: 'raw', eager: true }.)
const files = import.meta.glob('../content/guides/*.md', { as: 'raw', eager: true });

// Minimal frontmatter parser: a leading --- ... --- block of `key: value` lines.
function parseFrontmatter(raw) {
  const m = raw.match(/^---\s*\n([\s\S]*?)\n---\s*\n?([\s\S]*)$/);
  if (!m) return { meta: {}, body: raw };
  const meta = {};
  for (const line of m[1].split('\n')) {
    const idx = line.indexOf(':');
    if (idx === -1) continue;
    const key = line.slice(0, idx).trim();
    const val = line.slice(idx + 1).trim().replace(/^["']|["']$/g, '');
    if (key) meta[key] = val;
  }
  return { meta, body: m[2] };
}

export const guides = Object.entries(files)
  .map(([path, raw]) => {
    const slug = path.split('/').pop().replace(/\.md$/, '');
    const { meta, body } = parseFrontmatter(raw);
    return {
      slug,
      title: meta.title || slug,
      description: meta.description || '',
      date: meta.date || '',
      html: marked.parse(body),
    };
  })
  .sort((a, b) => (b.date || '').localeCompare(a.date || ''));

export const guideSlugs = guides.map((g) => g.slug);
export const getGuide = (slug) => guides.find((g) => g.slug === slug);
